const DEMO_SUBDOMAINS = ['atlassian', 'halo', 'vimi', 'zillow'].concat(['testing', 'staging', 'main']);

export default DEMO_SUBDOMAINS;
